/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { UpdateUserProfile } from "../../utilities/api/auth/auth-service";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UserDataObjType } from "../../utilities/types";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input, ImageUpload } from "../../components";
import { toast } from "react-toastify";
import { messages } from "../../utilities/Messages";
import { VALID_IMAGE_TYPES, DEFAULT_MAX_IMAGE_SIZE } from "../../utilities/imageUtils";
const UpdateProfile = () => {
  const navigate = useNavigate();
  const { UserProfileDetails, UserRole, profileErrorMessage } = useAppSelector(
    (state) => state.profileDetail
  );
  const getMessage = messages.profile;
  const { states } = useAppSelector((state) => state.states);
  const [schema, setSchema] = useState({
    firstName: yup
      .string()
      .required(getMessage.firstName_isNotEmpty)

      .min(3, getMessage.firstName_minLength)
      .max(30, getMessage.firstName_maxLength),
    lastName: yup
      .string()
      .required(getMessage.lastName_isNotEmpty)

      .min(1, getMessage.lastName_minLength)
      .max(30, getMessage.lastName_maxLength),
    addressLine1: yup
      .string()
      // .required(getMessage.addressLine1_isNotEmpty)
      .notRequired()
      .max(50, getMessage.addressLine1_maxLength),
    addressLine2: yup.string().nullable().notRequired().max(50, getMessage.addressLine2_maxLength),
    landmark: yup.string().nullable().notRequired().max(50, getMessage.landmark_maxLength),
    pincode: yup
      .string()
      // .required(getMessage.pincode_isNotEmpty)
      .notRequired(),
      // .matches(/^[1-9][0-9]{5}$/, getMessage.pincode_maxLength),
    city: yup
      .string()
      // .required(getMessage.city_isNotEmpty)
      .notRequired()
      .max(50, getMessage.city_maxLength),

    // state: yup.string().required(getMessage.state_isNotEmpty),
    state: yup.string().notRequired(),

    // gender: yup.string().required(getMessage.gender_isNotEmpty),
    gender: yup.string().notRequired(),
    image: yup
      .mixed()
      .test(getMessage.image_isValid, getMessage.image_isNotValid, (value: any) => {
        if (!value || (typeof value === "object" && !value?.length)) return true;
        if (typeof value === "string") return true;
        const file = value instanceof File ? value : value?.[0];
        if (!file) return true;
        return VALID_IMAGE_TYPES.includes(file.type);
      })
      .test(getMessage.file_size, getMessage.file_fixSize, (value: any) => {
        if (!value || (typeof value === "object" && !value?.length)) return true;
        if (typeof value === "string") return true;
        const file = value instanceof File ? value : value?.[0];
        if (!file) return true;
        return file.size <= DEFAULT_MAX_IMAGE_SIZE;
      }),
  });
  if (profileErrorMessage) {
    toast.error(profileErrorMessage.message)
  }
  const [newAadhar, setNewAadhar] = useState("");
  const maskedAadhar = UserProfileDetails?.aadharNumber || "";

  useEffect(() => {
    if (UserRole?.role?.name !== "END_USER") {
      setSchema(
        Object.assign(schema, {
          aadharNumber: yup
            .string()
            .notRequired()
            .test("aadhar-optional", getMessage.aadharNumber_maxLength, (value) => {
              if (!value || value.trim() === "") return true;
              return /^[0-9]\d{11}$/.test(value);
            }),
        })
      );
    }
  }, [UserRole?.role?.name]);

  const UserDataSchema = yup.object().shape(schema);

  const initialState = {
    firstName: UserProfileDetails?.firstName,
    lastName: UserProfileDetails?.lastName,
    phone: UserProfileDetails?.phone,
    email: UserProfileDetails?.email,
    gender: UserProfileDetails?.gender,
    birthDate: UserProfileDetails?.birthDate,
    userImage: UserProfileDetails?.userImage,
    addressLine1: UserProfileDetails?.addressLine1,
    addressLine2: UserProfileDetails?.addressLine2,
    city: UserProfileDetails?.city,
    state: UserProfileDetails?.state,
    country: UserProfileDetails?.country || "India",
    pincode: UserProfileDetails?.pincode,
    landmark: UserProfileDetails?.landmark,
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [imageError, setImageError] = useState("");

  const [userData, setUserData] = useState(initialState);
  const [birthDate, setBirthDate] = useState(
    UserProfileDetails?.birthDate?.split("/").reverse().join("-") || ""
  );

  useEffect(() => {
    setUserData(initialState);
  }, [UserProfileDetails]);

  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm<UserDataObjType>({
    resolver: yupResolver(UserDataSchema),
  });

  const handleCancel = () => {
    navigate("/profile");
  };
  let formData = new FormData();

  const onSubmit: SubmitHandler<any> = async (data) => {
    data.image = data.image?.[0] || "";
    if (newAadhar.trim()) {
      data.aadharNumber = newAadhar.trim();
    } else {
      delete data.aadharNumber;
    }

    formData.append("country", "India");
    for (let key in data) {
      formData.append(key, data[key]);
    }

    formData.append("birthDate", birthDate);
    const uploadImage = userData?.userImage || "";
    formData.append("image", uploadImage);
    formData.append("latitude", "");
    formData.append("longitude", "");
    const result = await UpdateUserProfile(formData);
    if (result.data.statusCode === 200) {
      navigate("/profile");
    } else {
      setErrorMessage(result.response.data.message);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <Card>
            <Card.Body>
              <Card.Title className="text-start">Update Profile</Card.Title>
              <h4
                className="card-title2 text-start"
                style={{ marginBottom: "37px" }}
              >
                Personal Information
              </h4>
              <hr />
              <ImageUpload
                value={userData?.userImage}
                onChange={(img) => setUserData({ ...userData, userImage: img || "" } as any)}
                onError={setImageError}
                error={imageError || (errors.image?.message as string) || ""}
                label="Upload Profile Photo"
                sizeLabel="Maximum file size 5MB"
                register={register}
                labelAs="h6"
              />
              <Row>
                <Col col={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="firstname" className="form-label">
                      First Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      defaultValue={userData?.firstName}
                      type="text"
                      placeholder="Enter First Name"
                      id="adduserfirstname"
                      name="firstName"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors.firstName?.message}
                    </span>
                  </div>
                </Col>
                <Col col={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="lastname" className="form-label">
                      Last Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      defaultValue={userData?.lastName}
                      type="text"
                      placeholder="Enter Last Name"
                      id="adduserlastname"
                      name="lastName"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors.lastName?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              {UserRole?.role?.name !== "END_USER" && (
                <Row>
                  <Col col={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="date" className="form-label">
                        Date of Birth
                      </label>
                      <Input
                        type="date"
                        defaultValue={birthDate}
                        onChange={(e: any) => setBirthDate(e.target.value)}
                        className="form-control"
                        id="birthDate"
                        name="birthDate"
                        formate="dd-mm-yyyy"
                        max={new Date().toISOString().split("T")[0]}
                      />
                      <span className="error-msg">
                        {errors.birthDate?.message}
                      </span>
                    </div>
                  </Col>
                  <Col col={6}>
                    <div className="mb-3 text-start">
                      <div className="d-flex align-items-center justify-content-between">
                        <label htmlFor="adhar" className="form-label">
                          Aadhar Number <small className="text-danger">*</small>
                        </label>
                        {maskedAadhar && (
                          <small className="text-muted">Current Aadhar: <span className="fw-semibold text-secondary">{maskedAadhar}</span></small>
                        )}
                      </div>
                      <Input
                        value={newAadhar}
                        onChange={(e: any) => setNewAadhar(e.target.value)}
                        type="text"
                        placeholder="Enter new Aadhar Number"
                        id="adduseradhar"
                        name="aadharNumber"
                        className="form-control"
                        maxLength={12}
                        onKeyDown={(e: any) =>
                          ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                        }
                      />
                      {newAadhar && !/^[0-9]{12}$/.test(newAadhar) && (
                        <span className="error-msg">{getMessage.aadharNumber_maxLength}</span>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="gender" className="form-label">
                      Gender
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <DropDown
                      defaultValue={userData?.gender}
                      name="gender"
                      id="addusergender"
                      className="form-control"
                      register={register}
                      // required
                    >
                      <option hidden disabled value="">
                        Select Gender
                      </option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </DropDown>
                    <span className="error-msg">{errors.gender?.message}</span>
                  </div>
                </Col>

              </Row>
              <h4 className="card-title2 text-start mt-3 mb-0">
                Address Information
              </h4>
              <hr className="mb-4" />
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address1" className="form-label">
                      Address line 1
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      defaultValue={userData?.addressLine1}
                      type="text"
                      placeholder="Enter Address line 1"
                      id="adduseraddress1"
                      name="addressLine1"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">
                      {errors.addressLine1?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address2" className="form-label">
                      Address line 2
                    </label>
                    <Input
                      defaultValue={userData?.addressLine2}
                      type="text"
                      placeholder="Enter Address line 2"
                      id="addressLine2"
                      name="addressLine2"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">
                      {errors.addressLine2?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="landmark" className="form-label">
                      Landmark
                    </label>
                    <Input
                      defaultValue={userData?.landmark}
                      type="text"
                      placeholder="Enter Landmark"
                      id="landmark"
                      name="landmark"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors.landmark?.message}
                    </span>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="pincode" className="form-label">
                      Pincode
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      defaultValue={userData?.pincode}
                      type="number"
                      placeholder="Enter Pincode"
                      id="adduserpincode"
                      name="pincode"
                      className="form-control"
                      register={register}
                      // required
                      onKeyDown={(e: any) =>
                        ["e", ".", "-", "+"].includes(e.key) &&
                        e.preventDefault()
                      }
                      onWheel={(e: any) => e.target.blur()}
                    />
                    <span className="error-msg">{errors.pincode?.message}</span>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="city" className="form-label">
                      City
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      defaultValue={userData?.city}
                      type="text"
                      placeholder="Enter City"
                      id="addusercity"
                      name="city"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">{errors.city?.message}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="state" className="form-label">
                      State
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <DropDown
                      defaultValue={userData?.state}
                      name="state"
                      id="adduserstate"
                      className="form-control"
                      register={register}
                      // required
                    >
                      <option hidden disabled value="">
                        Select State
                      </option>
                      {states?.map((item: any) => {
                        return (
                          <option key={item.code} value={item.name}>
                            {item.name}
                          </option>
                        );
                      })}
                    </DropDown>
                    <span className="error-msg">{errors.state?.message}</span>
                  </div>
                </Col>

              </Row>
              <hr />
              <Row>
                {errorMessage}
                <Col className="text-end">
                  <ButtonGroup>
                    <Button
                      onClick={() => handleCancel()}
                      type="button"
                      bname="Cancel"
                      name="cancel"
                      id="cancel"
                      className="btn btn-info rounded-1 me-3"
                    ></Button>
                    <Button
                      type="submit"
                      bname="Update"
                      name="update-profile"
                      id="update-profile"
                      className="btn btn-primary rounded-1"
                      disabled={!!(newAadhar && !/^[0-9]{12}$/.test(newAadhar))}
                    ></Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </form>
      </Container>
    </>
  );
};

export { UpdateProfile };
